<template>
  <div class="main-image">
    <img
      v-if="ignoreError"
      style="background-color: transparent"
      class="blur error"
      :alt="alt"
      ref="image"
      data-aos="zoom-out"
      :src="setSrc ? thumb : src"
    />
    <img
      v-else
      @error="checkImagesError"
      class="blur"
      data-aos="zoom-out"
      :alt="alt"
      ref="image"
      data-aos-easing="linear"
      data-aos-duration="600"
      :src="setSrc ? thumb : src"
    />
  </div>
</template>

<script>
import { onMounted, ref } from "vue";

export default {
  name: "ImageContainer",
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
    thumb: {
      type: String,
      required: false,
    },
    ignoreError: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const image = ref(null);
    const src = ref(props.src);
    const thumb = ref(props.thumb);

    var img_err_timeout;
    async function checkImagesError(e) {
      if (typeof window !== "undefined") {
        this.target =
          e.toElement || e.relatedTarget || e.target || e.currentTarget;

        this.target.style.border = "10px rgb(100, 100, 100) dashed";
        this.target.style.width = "96%";
        this.target.style.height = "96%";
        if (img_err_timeout) clearTimeout(img_err_timeout);
        img_err_timeout = setTimeout(
          (elem) => {
            this.source = elem.src;
            this.target.style.border = "";
            this.target.style.width = "100%";
            this.target.style.height = "100%";
            elem.src = this.source;
          },
          2000,
          this.target
        );
      }
    }

    function setOriginal() {
      try {
        if (image?.value?.src !== src.value) {
          image.value.src = src.value;

          /* eslint-disable no-empty */
          image.value.onload = () => {
            try {
              image.value.classList.remove("blur");
            } catch {}
          };
          /* eslint-disable no-empty */
        }
      } catch {}
    }

    const setSrc = thumb.value && typeof window !== "undefined";

    const handleLoad = () => {
      if (setSrc) {
        image.value.onload = () => setOriginal();
      } else {
        image.value.classList.remove("blur");
      }
    };

    onMounted(() => {
      handleLoad();
    });

    return {
      image,
      checkImagesError,
      setOriginal,
      setSrc,
    };
  },
};
</script>

<style lang="scss" scoped>
[data-aos^="zoom"][data-aos^="zoom"] {
  opacity: 1 !important;
  transition-property: opacity, transform;
}

.main-image {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
  background-repeat: no-repeat;
  background-size: cover;

  // img:after {
  //   font-weight: 900;
  //   font-family: "Font Awesome 5 Pro";
  //   content: "";
  //   display: block;
  //   font-size: 16px;
  //   font-style: normal;
  //   color: rgb(100, 100, 100);

  //   position: absolute;
  //   top: 40%;
  //   width: 100%;
  //   text-align: center;
  // }

  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%) !important;
    // transform-origin: top left;
    background-color: lightgray;
    filter: blur(0);
    transition: all 0.4s ease;

    &.blur {
      filter: blur(25px);
      // animation-name: example;s
      animation-duration: 0.5s;
      animation-delay: 0.5s;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
      image-rendering: smooth;
    }

    &.error {
      &::after {
        content: "" !important;
      }
    }

    // &.no-blur {
    // filter: blur(0);
    // image-rendering: pixelated;

    // animation-name: example;
    // animation-duration: 1s;
    // animation-delay: 0.8s;
    // animation-timing-function: ease-in-out;
    // animation-fill-mode: forwards;
    // }

    &:hover {
      transform: scale(1.14);
      // transform: scale(1.14) translate(-50%, -50%);
    }
  }
}
</style>
